exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._1DpvT8Kep6sy_iBfQFUSSm {\n    margin-right: 1.2em;\n    color: #222222;\n}\n\n._1DpvT8Kep6sy_iBfQFUSSm:hover {\n    color: dodgerblue;\n}", ""]);

// Exports
exports.locals = {
	"linkIcon": "_1DpvT8Kep6sy_iBfQFUSSm"
};